import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin, Radio, Select, Modal } from "antd";
import {
  MinusSquareFilled,
  PlusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import verifybtn from "../../image/verifybtn.png";
import PhoneInput from "react-phone-input-2";
import VerifyBankOtpModal from "../../authentication/VerifyBankOtpModal";
const BankDetailsForWithoutStep = ({
  VendorId,
  bankdetailsIDs,
  SetBankDetailsIDs,
  gstVendorId,
  gstValue,
  CompanyId,
  setShowPaymentCollapse,
}) => {
  const { t } = useTranslation();
  // const VendorId = id ? atob(id) : null;
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  const [gstNumber, setGstNumber] = useState([]);
  const [minutes, setMinutes] = useState(1);
  const [OTP, setOTP] = useState(null);
  const [seconds, setSeconds] = useState(0);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [checkFormValueChange, setCheckFormValueChange] = useState(false);
  const [checkVerificationDone, setCheckVerificationDone] = useState(false);
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  const [stateChange, setStateChange] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const stateChangeRef = useRef(false);
  const formRef = useRef();
  const initialState = {
    person_name: null,
    email: null,
    phone_number: null,
    bankdetails: [
      {
        id: null,
        account_holder_name: null,
        account_number: null,
        bank_name: null,
        branch_name: null,
        ifsc_code: null,
        same_for_all_billing_addresses: false,
        gstn: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor-bank-detail/?vendor=${VendorId}`
        );
        if (apiResponse.data.success) {
          setState({
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
            bankdetails: apiResponse.data.data.map((bankDetail) => {
              const {
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,

                id: rest?.id ? rest?.id : null,

                same_for_all_billing_addresses:
                  rest.same_for_all_billing_addresses
                    ? rest.same_for_all_billing_addresses
                    : false,
              };
            }),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const {
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,
                id: rest?.id ? rest?.id : null,

                same_for_all_billing_addresses:
                  rest.same_for_all_billing_addresses
                    ? rest.same_for_all_billing_addresses
                    : false,
              };
            }
          );

          setWeightSizeBankFieldValue(modifiedBankDetails);
          formRef.current?.setFieldsValue({
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
          });
          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    const getGstVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor-bank-detail/bank-details-by-gst/?gst_no=${gstValue}`
        );
        if (apiResponse.data.success) {
          setState({
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
            bankdetails: apiResponse.data.data.map((bankDetail) => {
              const {
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,

                id: rest?.id ? rest?.id : null,
              };
            }),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const {
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,

                id: rest?.id ? rest?.id : null,
              };
            }
          );

          setWeightSizeBankFieldValue(modifiedBankDetails);
          formRef.current?.setFieldsValue({
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
          });
          SetBankDetailsIDs(apiResponse?.data?.data[0]?.id);
          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else if (apiResponse.data.success === false) {
          setState({
            phone_number: apiResponse.data.data?.phone_number
              ? apiResponse.data.data?.phone_number
              : "+91",
            email: apiResponse.data.data?.email
              ? apiResponse.data.data?.email
              : null,
            name: apiResponse.data.data?.name
              ? apiResponse.data.data?.name
              : null,
            bankdetails: apiResponse.data.data.map((bankDetail) => {
              const {
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,

                id: rest?.id ? rest?.id : null,
              };
            }),
          });

          const modifiedBankDetails = apiResponse.data.data.map(
            (bankDetail) => {
              const {
                vendor,
                vendor_name,
                phone_number_otp,
                phone_verified,
                phone_number,
                email,
                name,
                ...rest
              } = bankDetail;
              return {
                ...rest,

                id: rest?.id ? rest?.id : null,
              };
            }
          );
          formRef.current?.setFieldsValue({
            phone_number: apiResponse.data.data[0]?.phone_number
              ? apiResponse.data.data[0]?.phone_number
              : "+91",
            email: apiResponse.data.data[0]?.email
              ? apiResponse.data.data[0]?.email
              : null,
            name: apiResponse.data.data[0]?.name
              ? apiResponse.data.data[0]?.name
              : null,
          });
          setWeightSizeBankFieldValue(modifiedBankDetails);
          SetBankDetailsIDs(null);
          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    if (VendorId !== null && gstVendorId === null) {
      getVendorOnboarding();
    }
    if (gstVendorId !== null) {
      getGstVendorOnboarding();
    }
  }, [VendorId, gstVendorId, t, gstValue]);

  useEffect(() => {
    GetGstNumber();
  }, [VendorId]);

  useEffect(() => {
    setIsButtonDisabled(!isStateValid(state));
  }, [state]); 
  useEffect(() => {
    if (!stateChangeRef.current) {
      stateChangeRef.current = true;
      setStateChange(true);
    }
  }, [state]);
  const GetGstNumber = async (value) => {
    const apiResponse = await getRequest(
      `vendor-suppliers-billing-details/get-gstnumber-suppliers-detail/?vendor_id=${VendorId}&company_id=${CompanyId}`
    );
    if (apiResponse.data.success) {
      setGstNumber(apiResponse.data.data);
    }
  };
  const isStateValid = (state) => {
    const { phone_number, email, name, bankdetails } = state;
    const phone =
      phone_number !== "+91" && /^\d{12}$/.test(phone_number)
        ? phone_number
        : null;
    const isValidEmail = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!phone || !isValidEmail || !name) {
      return false;
    }

    const isValidBankDetail = bankdetails.some((bank) => {
      return (
        bank.account_holder_name &&
        bank.account_number &&
        bank.bank_name &&
        bank.branch_name &&
        bank.ifsc_code &&
        bank.gstn
      );
    });

    return isValidBankDetail;
  };
  const handleBankInputChange = (field, e, index) => {
    let newBankArr = state.bankdetails;
    newBankArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, bankdetails: newBankArr });
    setStateChange(true);
  };
  const addBank = () => {
    let newBankArr = [
      ...state.bankdetails,
      {
        id: null,
        account_holder_name: null,
        account_number: null,
        bank_name: null,
        branch_name: null,
        ifsc_code: null,
        same_for_all_billing_addresses: false,
        gstn: null,
      },
    ];
    setCheckFormValueChange(true);
    setState({ ...state, bankdetails: newBankArr });

    setWeightSizeBankFieldValue(newBankArr);
  };

  const removeBank = async (lastIndex) => {
    let filterBankArr = state.bankdetails.filter(
      (item, index) => index !== lastIndex
    );
    setCheckFormValueChange(true);
    setState({ ...state, bankdetails: filterBankArr });

    setWeightSizeBankFieldValue(filterBankArr);
  };

  const setWeightSizeBankFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["account_holder_name" + objectKey] =
        objectValue.account_holder_name;
      fieldObject["account_number" + objectKey] = objectValue.account_number;
      fieldObject["bank_name" + objectKey] = objectValue.bank_name;
      fieldObject["branch_name" + objectKey] = objectValue.branch_name;
      fieldObject["ifsc_code" + objectKey] = objectValue.ifsc_code;
      fieldObject["same_for_all_billing_addresses" + objectKey] =
        objectValue.same_for_all_billing_addresses;
      fieldObject["gstn" + objectKey] = objectValue.gstn;
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  const handleSendOtpPhone = async () => {
    setIsModalOpenPhone(true);
    try {
      const payload = {
        phone_number: state?.phone_number ? state.phone_number : "",
      };
      const response = await postRequest(
        `vendor-bank-detail/phone-number-verify/?vendor_id=${VendorId}`,
        payload
      );
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/;

        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyPhoneButtonView(false);

          setState((prevState) => ({
            ...prevState,
            phone_verified: true,
          }));
          setVerificationResultContact("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            phone_verified: false,
          }));
          showModalPhone();
          setVerifyPhoneButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        setVerificationResultContact("");
        setVerifyPhoneButtonView(true);
      }
    } catch (error) {
      setVerifyPhoneButtonView(true);
      setVerificationResultContact("");
    }
  };
  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };

  const handleCancel = () => {
    setIsModalOpenPhone(false);
    setOTP(null);
    setSeconds(30);
    setMinutes(1);
    setBtnLoading(false);
  };

  const handleSubmit = async () => {
    const payload = {
      email: state?.email || "",
      phone_number: state?.phone_number || "",
      name: state?.name || "",
      bankdetails:
        state.bankdetails &&
        state.bankdetails.every(
          (bank) =>
            bank.account_holder_name === null &&
            bank.account_number === null &&
            bank.bank_name === null &&
            bank.branch_name === null &&
            bank.ifsc_code === null
        )
          ? []
          : state.bankdetails,
    };
    try {
      setBtnLoading(true);
      let response;
      if (bankdetailsIDs === null) {
        const url =
          VendorId !== null
            ? `vendor-bank-detail/${VendorId}/add-bank-details/`
            : `vendor-bank-detail/${gstVendorId}/add-bank-details/`;
        response = await patchRequest(url, payload);
      } else {
        const url =
          VendorId !== null
            ? `vendor-bank-detail/${VendorId}/`
            : `vendor-bank-detail/${gstVendorId}/`;

        response = await patchRequest(url, payload);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          bankdetailsIDs === null
            ? t("bankdetail_added_successfully")
            : t("bankdetail_updated_successfully")
        );
        setShowPaymentCollapse(true);

        setStateChange(false);
        setCheckFormValueChange(false);
        stateChangeRef.current = false;
        bankdetailsIDs
          ? setState({
              phone_number: response.data.data[0]?.phone_number
                ? response.data.data[0]?.phone_number
                : "+91",
              email: response.data.data[0]?.email
                ? response.data.data[0]?.email
                : null,
              name: response.data.data[0]?.name
                ? response.data.data[0]?.name
                : null,
              bankdetails: response.data.data.map((bankDetail) => {
                const {
                  vendor,
                  vendor_name,
                  phone_number_otp,
                  phone_verified,
                  phone_number,
                  email,
                  name,
                  ...rest
                } = bankDetail;
                return {
                  ...rest,

                  id: rest?.id ? rest?.id : null,
                };
              }),
            })
          : setState({
              // ...filteredResponse,
              phone_number: response.data.data?.bankdetails[0]?.phone_number
                ? response.data.data?.bankdetails[0].phone_number
                : "+91",
              email: response.data.data?.bankdetails[0].email
                ? response.data.data?.bankdetails[0].email
                : null,
              name: response.data.data?.bankdetails[0].name
                ? response.data.data?.bankdetails[0].name
                : null,
              bankdetails: response.data.data.bankdetails?.map((bankDetail) => {
                const {
                  vendor,
                  vendor_name,
                  phone_number_otp,
                  phone_verified,
                  phone_number,
                  email,
                  name,
                  ...rest
                } = bankDetail;
                return {
                  ...rest,

                  id: rest?.id ? rest?.id : null,
                };
              }),
            });
        SetBankDetailsIDs(response.data.data.bankdetails[0].id);
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  const handleSameForAllBillingAddressesChange = (index, value) => {
    const newBankDetails = [...state.bankdetails];
    newBankDetails[index].same_for_all_billing_addresses = value;
    setStateChange(true);
    setState({ ...state, bankdetails: newBankDetails });
  };

  const handleCloneSelectChange = (field, value, index) => {
    let newFeatureArr = state.bankdetails;
    if (newFeatureArr[index]) {
      newFeatureArr[index][field] = value;
      setState({ ...state, bankdetails: newFeatureArr });
      setStateChange(true);
    }
  };

  const phoneValidLength = state?.phone_number;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }

    return Promise.resolve();
  };

  const handlePhoneInputChange = (phone) => {
    setState((prevState) => ({
      ...prevState,
      phone_number: phone,
      phone_verified: false,
    }));
    setStateChange(true);
  };
  const handleBankEmailChange = (mail) => {
    setState((prevState) => ({
      ...prevState,
      email: mail,
    }));
    setStateChange(true);
  };
  const handlePersonChange = (person) => {
    setState((prevState) => ({
      ...prevState,
      name: person,
    }));
    setStateChange(true);
  };
  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          onValuesChange={() => setCheckFormValueChange(true)}
        >
          {state.bankdetails &&
            state.bankdetails.map((x, index) => {
              return (
                <Row
                  key={index}
                  gutter={[15]}
                  className="bank_details_sec"
                >
                  <Col xs={24} sm={22} md={22} xl={22} xxl={22}>
                    <Row gutter={[16]}>
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        xl={6}
                        xxl={6}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name={`account_holder_name` + index}
                          label={t("label_account_holder_name")}
                          rules={[
                            {
                              required: true,
                              pattern: /^[A-Za-z\s]+$/,
                              message: (
                                <Trans>{t("Please Enter Valid Name")}</Trans>
                              ),
                            },
                            {
                              min: 3,
                              message: <Trans>{t("minlength_msg")}</Trans>,
                            },
                            {
                              max: 30,
                              message: (
                                <Trans>{t("maxlength_personName")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            className="cust-input"
                            placeholder={t("pl_account_holder_name")}
                            onChange={(value) =>
                              handleBankInputChange(
                                "account_holder_name",
                                value,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        xl={6}
                        xxl={6}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name={`account_number` + index}
                          label={t("label_account_number")}
                          rules={[
                            {
                              required: true,
                              pattern: "^[0-9]{9,18}$",
                              message: "Please enter valid account number",
                            },
                          ]}
                        >
                          <Input
                            className="cust-input"
                            placeholder={t("pl_account_number")}
                            onChange={(value) =>
                              handleBankInputChange(
                                "account_number",
                                value,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        xl={6}
                        xxl={6}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name={`bank_name` + index}
                          label={t("label_bank_name")}
                          rules={[
                            {
                              required: true,
                              pattern: /^[A-Za-z\s]+$/,
                              message: (
                                <Trans>{t("Please Enter Valid Name")}</Trans>
                              ),
                            },
                            {
                              min: 3,
                              message: <Trans>{t("minlength_msg")}</Trans>,
                            },
                            {
                              max: 30,
                              message: (
                                <Trans>{t("maxlength_designation")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            className="cust-input"
                            placeholder={t("pl_bank_name")}
                            onChange={(value) =>
                              handleBankInputChange("bank_name", value, index)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        xl={6}
                        xxl={6}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name={`branch_name` + index}
                          label={t("label_branch_name")}
                          rules={[
                            {
                              required: true,

                              message: (
                                <Trans>
                                  {t("Please Enter Valid Branch Name")}
                                </Trans>
                              ),
                            },
                            {
                              min: 3,
                              message: <Trans>{t("minlength_msg")}</Trans>,
                            },
                            {
                              max: 30,
                              message: (
                                <Trans>{t("maxlength_designation")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            className="cust-input"
                            placeholder={t("pl_branch_name")}
                            onChange={(value) =>
                              handleBankInputChange("branch_name", value, index)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        xl={6}
                        xxl={6}
                        className="TextFeild gutter-row"
                      >
                        <Form.Item
                          name={`ifsc_code` + index}
                          label={t("label_ifsc_code")}
                          rules={[
                            {
                              required: true,

                              message: (
                                <Trans>
                                  {t("Please Enter Valid IFSC Code")}
                                </Trans>
                              ),
                            },
                            {
                              min: 3,
                              message: <Trans>{t("minlength_msg")}</Trans>,
                            },
                            {
                              max: 30,
                              message: (
                                <Trans>{t("maxlength_designation")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            className="cust-input"
                            placeholder={t("pl_ifsc_code")}
                            onChange={(value) =>
                              handleBankInputChange("ifsc_code", value, index)
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        xl={6}
                        xxl={6}
                        className="TextFeild gutter-row"
                      >
                        <Space align="center">
                          <Form.Item
                            className="radioitem radio2"
                            name={`same_for_all_billing_addresses` + index}
                            label={
                              <span style={{ whiteSpace: "normal" }}>
                                {t("Same For All Billing Addresses")}
                              </span>
                            }
                            initialValue={false}
                            rules={[
                              {
                                required: true,
                                message: <Trans>{t("Select Value")}</Trans>,
                              },
                            ]}
                          >
                            <Radio.Group
                              value={
                                state.bankdetails[index]
                                  .same_for_all_billing_addresses
                              }
                              onChange={(e) =>
                                handleSameForAllBillingAddressesChange(
                                  index,
                                  e.target.value
                                )
                              }
                            >
                              <Radio value={true}>Yes</Radio>
                              <Radio value={false}>No</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Space>
                      </Col>
                      <Col   xs={24}
                        sm={12}
                        md={8}
                        xl={6}
                        xxl={6}>
                        <Form.Item
                          name={`gstn` + index}
                          label={t("GSTIN")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("Select GSTIN")}</Trans>,
                            },
                          ]}
                        >
                          <Select
                            showArrow
                            showSearch
                            placeholder={t("Select GSTN")}
                            onChange={(value) =>
                              handleCloneSelectChange("gstn", value, index)
                            }
                            optionFilterProp="children"
                          >
                            {gstNumber &&
                              gstNumber.length > 0 &&
                              gstNumber.map((item) => (
                                <Select.Option
                                  key={item.gst_number}
                                  value={item.gst_number}
                                >
                                  {item.gst_number}
                                </Select.Option>
                              ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} sm={2} md={2} xl={2} xxl={2}>
                    <div className="addwrp">
                      <Space>
                        {index !== 0 ? (
                          <MinusSquareFilled
                            className="add"
                            onClick={() => removeBank(index)}
                          />
                        ) : (
                          ""
                        )}

                        {!x.same_for_all_billing_addresses ? (
                          <PlusSquareFilled
                            className="add"
                            onClick={(e) => addBank(e)}
                          />
                        ) : (
                          ""
                        )}
                      </Space>
                    </div>
                  </Col>
                </Row>
              );
            })}
          <h6>Responsible Person for Bank Details Modification:</h6>
          <Row gutter={[16]}>
            <Col
              xs={24}
              sm={12}
              md={8}
              xl={6}
              xxl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="name"
                label={t("label_person_name")}
                rules={[
                  {
                    required: true,

                    message: <Trans> {t("val_person_name")}</Trans>,
                  },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Please Enter Valid Name",
                  },
                ]}
              >
                <Input
                  value={state?.name}
                  className="cust-input"
                  placeholder={t("pl_person_name")}
                  onChange={(e) => handlePersonChange(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={8}
              xl={6}
              xxl={6}
              className="TextFeild gutter-row"
            >
              <Form.Item
                name="email"
                label={t("label_email")}
                rules={[
                  {
                    required: true,

                    message: <Trans> {t("val_email")}</Trans>,
                  },
                ]}
              >
                <Input
                  value={state?.email}
                  className="cust-input"
                  placeholder={t("pl_email_2")}
                  onChange={(e) => handleBankEmailChange(e.target.value)}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6} xl={6} xxl={6}>
              <div className="verifywrap">
                <Form.Item
                  name="phone_number"
                  label={t("label_mobileNumber")}
                  placeholder={t("pl_mobileNumber")}
                  rules={[
                    {
                      required: true,
                      validator: validatePhoneNumber,
                      message: <Trans> {t("val_mobileNumber")}</Trans>,
                    },
                  ]}
                >
                  <div className="verifywrap">
                    <div className="phonefield">
                      <PhoneInput
                        className="PhoneSection"
                        country={"in"}
                        value={state.phone_number}
                        onChange={(value) => handlePhoneInputChange(value)}
                      />
                    </div>
                  </div>
                </Form.Item>

                {verificationResultContact === "success" && (
                  <img
                    src={verifybtn}
                    style={{ height: "36px", marginTop: "29px" }}
                  ></img>
                )}
              </div>
              <Modal
                className="ModelPopupSec"
                title={"Verify Mobile"}
                open={isModalOpenPhone}
                onOk={handleCancel}
                onCancel={handleCancel}
                closable={handleCancel}
                wrapClassName="modal-wrapper"
                keyboard={false}
              >
                <VerifyBankOtpModal
                  handleCancel={handleCancel}
                  setVerifyEmailButtonView={setVerifyEmailButtonView}
                  OTP={OTP}
                  setOTP={setOTP}
                  state={state}
                  setState={setState}
                  setMinutes={setMinutes}
                  setSeconds={setSeconds}
                  seconds={seconds}
                  minutes={minutes}
                  VendorId={VendorId}
                  setVerificationResultEmail={setVerificationResultEmail}
                  setCheckVerificationDone={setCheckVerificationDone}
                  checkVerificationDone={checkVerificationDone}
                  setCheckFormValueChange={setCheckFormValueChange}
                  handleSubmitVendor={handleSubmit}
                />
              </Modal>
            </Col>
          </Row>
          
          {VendorId || gstVendorId ? (
            <div className="subbuttonsrow">
              {" "}
              {verifyGstButtonView === true && bankdetailsIDs !== null ? (
                <ButtonField
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={
                    checkFormValueChange &&
                    stateChange
                      ? handleSendOtpPhone
                      : handleSubmit
                  }
                  label={
                    checkFormValueChange &&
                    stateChange
                      ? t("VerifyOtp & Save")
                      : t("Save")
                  }
                  loading={btnLoading}
                  disabled={isButtonDisabled} 
                />
              ) : (
                <ButtonField
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={handleSubmit}
                  label={t("Save")}
                  loading={btnLoading}
                  disabled={isButtonDisabled} 
                />
              )}
            </div>
          ) : (
            ""
          )}
        </Form>
      </Spin>
    </>
  );
};
BankDetailsForWithoutStep.propTypes = {
  VendorId: PropTypes.number,
  bankdetailsIDs: PropTypes.func,
  SetBankDetailsIDs: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
  CompanyId: PropTypes.number,
  setShowPaymentCollapse: PropTypes.func,
};
export default BankDetailsForWithoutStep;
